import {
    COMMUNITY_PARTICIPANT_LIST_REQUEST,
    COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST,
    COMMUNITY_PARTICIPANT_LIST_INVALIDATION,
    COMMUNITY_MEMBERS_LIST_REQUEST,
    COMMUNITY_MEMBERS_LIST_RESPONSE,
    COMMUNITY_MEMBERS_LIST_CACHED_RESPONSE,
    COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE,
    COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST,
    COMMUNITY_MEMBERS_ADD_LIST_REQUEST,
    COMMUNITY_MEMBERS_ADD_LIST_RESPONSE,
    COMMUNITY_MANAGERS_LIST_REQUEST,
    COMMUNITY_MANAGERS_LIST_RESPONSE,
    COMMUNITY_MANAGERS_LIST_CACHED_RESPONSE,
    COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE,
    COMMUNITY_FOLLOWERS_LIST_REQUEST,
    COMMUNITY_FOLLOWERS_LIST_RESPONSE,
    COMMUNITY_FOLLOWERS_LIST_CACHED_RESPONSE,
    COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE,
    COMMUNITY_INVITED_LIST_REQUEST,
    COMMUNITY_INVITED_LIST_RESPONSE,
    COMMUNITY_INVITED_LIST_CACHED_RESPONSE,
    COMMUNITY_INVITED_LIST_ERROR_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST,
    COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_CACHED_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE
} from "./action-types"

import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"

import {
    listPageRequest as presentationListRequest,
    listResponse as presentationListResponse
} from "./default-actions/presentation-actions"

// Community Participant Paging Actions
// Used to reset the paging request limit/offset and select the appropriate participantType action
export const communityParticipantListRequest = (
    participantType,
    pagingRequest
) => ({
    type: COMMUNITY_PARTICIPANT_LIST_REQUEST,
    participantType,
    pagingRequest: {
        ...(pagingRequest || {}),
        limit: 10,
        offset: 0,
        nextOffset: 0
    }
})
export const communityParticipantListSearchRequest = searchCriteria => {
    if (
        searchCriteria &&
        !searchCriteria.get("communityId") &&
        searchCriteria.get("excluding_communities")
    ) {
        searchCriteria = searchCriteria
            .set("communityId", searchCriteria.get("excluding_communities"))
            .remove("excluding_communities")
    }
    return {
        type: COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST,
        searchCriteria
    }
}
export const communityParticipantListInvalidation = communityId => ({
    type: COMMUNITY_PARTICIPANT_LIST_INVALIDATION,
    communityId
})

// Community Members Paging Actions
export const communityMembersListRequest = listRequest(
    COMMUNITY_MEMBERS_LIST_REQUEST
)
export const communityMembersListResponse = listResponse(
    COMMUNITY_MEMBERS_LIST_RESPONSE
)
export const communityMembersListCachedResponse = listCachedResponse(
    COMMUNITY_MEMBERS_LIST_CACHED_RESPONSE
)
export const communityMembersListErrorResponse = listErrorResponse(
    COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE
)

// Community Members Add Paging Actions (for searching for users to add as members to the community)
export const communityMembersAddListSearchRequest = searchCriteria => {
    if (
        searchCriteria &&
        !searchCriteria.get("excluding_communities") &&
        searchCriteria.get("communityId")
    ) {
        searchCriteria = searchCriteria
            .set("excluding_communities", searchCriteria.get("communityId"))
            .remove("communityId")
    }
    return {
        type: COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST,
        searchCriteria
    }
}
const communityMembersAddListResponse = presentationListResponse(
    COMMUNITY_MEMBERS_ADD_LIST_RESPONSE
)
export const communityMembersAddListRequest = presentationListRequest(
    COMMUNITY_MEMBERS_ADD_LIST_REQUEST,
    communityMembersAddListResponse
)

// Community Managers Paging Actions
export const communityManagersListRequest = listRequest(
    COMMUNITY_MANAGERS_LIST_REQUEST
)
export const communityManagersListResponse = listResponse(
    COMMUNITY_MANAGERS_LIST_RESPONSE
)
export const communityManagersListCachedResponse = listCachedResponse(
    COMMUNITY_MANAGERS_LIST_CACHED_RESPONSE
)
export const communityManagersListErrorResponse = listErrorResponse(
    COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE
)

// Community Followers Paging Actions
export const communityFollowersListRequest = listRequest(
    COMMUNITY_FOLLOWERS_LIST_REQUEST
)
export const communityFollowersListResponse = listResponse(
    COMMUNITY_FOLLOWERS_LIST_RESPONSE
)
export const communityFollowersListCachedResponse = listCachedResponse(
    COMMUNITY_FOLLOWERS_LIST_CACHED_RESPONSE
)
export const communityFollowersListErrorResponse = listErrorResponse(
    COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE
)

// Community Invited Paging Actions
export const communityInvitedListRequest = listRequest(
    COMMUNITY_INVITED_LIST_REQUEST
)
export const communityInvitedListResponse = listResponse(
    COMMUNITY_INVITED_LIST_RESPONSE
)
export const communityInvitedListCachedResponse = listCachedResponse(
    COMMUNITY_INVITED_LIST_CACHED_RESPONSE
)
export const communityInvitedListErrorResponse = listErrorResponse(
    COMMUNITY_INVITED_LIST_ERROR_RESPONSE
)

// Community Awaiting Approval Paging Actions
export const communityAwaitingApprovalListRequest = listRequest(
    COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST
)
export const communityAwaitingApprovalListResponse = listResponse(
    COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE
)
export const communityAwaitingApprovalListCachedResponse = listCachedResponse(
    COMMUNITY_AWAITING_APPROVAL_LIST_CACHED_RESPONSE
)
export const communityAwaitingApprovalListErrorResponse = listErrorResponse(
    COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE
)
